import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { CanalVendaMultiselectComponent } from './canal-venda-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        CanalVendaMultiselectComponent
    ],
    exports: [
        CanalVendaMultiselectComponent
    ]
})
export class CanalVendaMultiselectModule { }
